import type { ClientEventCode } from "../types";
import { errorReporter } from "./errorReporter";

export function reportClientError(error: unknown, code: ClientEventCode) {
  const err = error instanceof Error ? error : new Error(String(error));

  err.name = code;
  errorReporter.sendError(err);
}
